import { formatMoney } from "@/domain/invoices/formatInvoice";

/** Credit note amounts are shown as negative (credit) using the same currency style as invoices. */
export function formatCreditNoteMoney(amountMinor: number, currency: string): string {
  return formatMoney(-Math.abs(amountMinor), currency);
}

export function shortenPayLinkUrl(url: string): string {
  if (!url) return "";
  try {
    const u = new URL(url);
    const path = u.pathname.replace(/^\/i\//, "invoice.stripe.com/i/…/");
    return path.length > 28 ? `${path.slice(0, 28)}…` : path;
  } catch {
    return url.length > 28 ? `${url.slice(0, 28)}…` : url;
  }
}
